import { useEffect, useState } from 'react'
import MobileLayout from './MobileLayout';
import DesktopLayout from './DesktopLayout';

interface CookieBannerProps {
  onCustomize: () => void
  onAcceptAll: () => void
  onRejectAll: () => void
  isMobile: boolean
}

export default function CookieBanner({ onCustomize, onAcceptAll, onRejectAll, isMobile, onClose }: CookieBannerProps) {
  const [isVisible, setIsVisible] = useState(false)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)

    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent')
    const decisionMade = localStorage.getItem('cookieDecisionMade')

    if (!cookieConsent && !decisionMade) {
      // Small delay to ensure smooth page load
      const timer = setTimeout(() => setIsVisible(true), 1500)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAcceptAll = () => {
    onAcceptAll()
    setIsVisible(false)
  }

  const handleRejectAll = () => {
    onRejectAll()
    setIsVisible(false)
  }

  const handleCustomize = () => {
    onCustomize()
    setIsVisible(false)
  }

  if (!isClient || !isVisible) {
    return null
  }
  const Layout = isMobile ? MobileLayout : DesktopLayout;
  const handleClose = () => {
    onClose()
    setIsVisible(false)
  }
  return (
    <Layout
      setIsVisible={setIsVisible}
      handleCustomize={handleCustomize}
      handleRejectAll={handleRejectAll}
      handleAcceptAll={handleAcceptAll}
      isOpen={isVisible}
      setIsOpen={setIsVisible}
      onClose={handleClose}
    />
  );
}
